import React from 'react'
import { Typography } from '@mui/material'

function CommonMapFunction(props) {
  const { data } = props
  
  return (
    <div className="customerPolicyLayout">
      {data?.map((item, index) => (
        <div key={index} className="policyContentSection">
          <Typography className="policyTitle">
            {item?.title}
          </Typography>
          {item.content && <Typography className="policyDescription">
            {item.content}
          </Typography>}
        </div>
      ))}
    </div>
  )
}

export default CommonMapFunction